/* =========================================================
   COMPETITIONS
========================================================= */
import React from "react";

import SectionHeader from "./SectionHeader";

const CompetitionSection = ({ data }) => (
    <section id="competitions">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="competition-grid">

                {(data.items || []).map((item, i) => (
                    <div className="competition-card" key={i}>

                        <div className="competition-number">
                            COMPETITION {String(i + 1).padStart(2, "0")}
                        </div>

                        <div className="competition-icon">
                            {item.icon}
                        </div>

                        <h3>{item.title}</h3>

                        <p>{item.description}</p>

                        <a
                            href={item.url || "#"}
                            className="learn-more"
                        >
                            {item.linkText || "Explore competition →"}
                        </a>

                    </div>
                ))}


            </div>
            <a href="/rect/competitions" className="learn-more">{"Learn more →"}</a>

        </div>

    </section>
);

export default CompetitionSection;